module.exports = __webpack_public_path__ + "static/media/feuerloescher_loesung.10206335.jpg";